import * as Sentry from '@sentry/react'
import { env } from '../../env'

const SENTRY_DSN =
  'https://a973d4e942ee72eb48d40d16e61f4b74@o4510763174920192.ingest.us.sentry.io/4510982488653824'

export function initSentry(): void {
  // When imported as a package into Publish, Publish's Sentry.init() has already run.
  // @sentry/react is a singleton — captureException etc. route to the existing client.
  if (Sentry.getClient()) {
    return
  }

  if (env.NODE_ENV !== 'production') {
    return
  }

  const release =
    env.VITE_COMMIT_HASH && env.VITE_COMMIT_HASH !== 'undefined'
      ? env.VITE_COMMIT_HASH
      : 'unknown'

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: env.NODE_ENV,
    release: `app-shell@${release}`,

    integrations: [Sentry.browserTracingIntegration()],

    sendDefaultPii: false,
    sampleRate: 0.25,
    tracesSampleRate: 0.001,

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Network request failed',
      'Load failed',
      'Failed to fetch',
      'Script error.',
    ],

    denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//],
  })
}
